import React, { useEffect, useRef, useState } from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisitenkarteIhresHauses() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [offsetY, setOffsetY] = useState(0);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const scrolled = window.scrollY;
      setOffsetY(scrolled * 0.15);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="visitenkarte-ihres-hauses" ref={sectionRef} className="relative min-h-screen w-full overflow-hidden bg-background pt-20 lg:pt-0 flex items-center">
      <div className="container mx-auto px-4 md:px-6 h-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center h-full min-h-[80vh]">
          {}
          <div className="flex flex-col justify-center space-y-8 z-10 order-2 lg:order-1 pb-12 lg:pb-0">
            <div className="space-y-4">
              {}
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight text-primary leading-[1.1]">
                <span className="block overflow-hidden">
                  <span className={`block transition-transform duration-1000 ease-out ${isVisible ? "translate-y-0" : "translate-y-full"}`}>
                    Eine Rolltreppe ist
                  </span>
                </span>
                <span className="block overflow-hidden">
                  <span className={`block transition-transform duration-1000 delay-150 ease-out ${isVisible ? "translate-y-0" : "translate-y-full"}`}>
                    wie eine <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70 decoration-accent underline decoration-4 underline-offset-4">Visitenkarte...</span>
                  </span>
                </span>
                <span className="block mt-4 md:mt-6 text-2xl md:text-3xl lg:text-4xl font-medium text-muted-foreground">
                  <span className="block overflow-hidden">
                    <span className={`block transition-transform duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0" : "translate-y-full"}`}>
                      Der erste Eindruck ist
                    </span>
                  </span>
                  <span className="block overflow-hidden">
                    <span className={`block transition-transform duration-1000 delay-450 ease-out ${isVisible ? "translate-y-0" : "translate-y-full"}`}>
                      durch nichts zu ersetzen!
                    </span>
                  </span>
                </span>
              </h1>

              {}
              <div className={`max-w-xl transition-opacity duration-1000 delay-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                <p className="text-lg text-muted-foreground leading-relaxed">Professionelle Spezialreinigung von Rolltreppen und Fahrsteigen seit 2000: schonend, zuverlässig – und das Beste: wir reinigen, wenn Ihre Kunden schlafen.</p>
              </div>
            </div>

            {}
            <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 delay-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Button asChild size="lg" className="h-14 px-8 text-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl hover:shadow-2xl transition-all duration-300 group">
                <Link to="/CleaningDetailPage">Spezialreinigung - Rolltreppen und Fahrsteige!<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/VisitenkarteIhresHauses.tsx|sig:2w84f7" data-ast-start="3995" data-ast-end="4081"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
            </div>

            {}
            
          </div>

          {}
          <div className="relative h-[50vh] lg:h-full w-full flex items-center justify-center order-1 lg:order-2 perspective-1000">
            <div ref={imageRef} className="relative w-full h-full max-h-[800px] flex items-center justify-center" style={{
            transform: `translateY(${offsetY * 0.5}px)`
          }}>
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-accent/10 to-transparent rounded-3xl transform rotate-3 scale-95 opacity-0 lg:opacity-100 transition-opacity duration-1000 delay-500" />
              
              {}
              <div className={`relative w-full h-full overflow-hidden rounded-2xl shadow-2xl transition-all duration-1500 ease-out transform ${isVisible ? "opacity-100 translate-x-0 rotate-0 scale-100" : "opacity-0 translate-x-20 rotate-2 scale-95"}`}>
                <div className="absolute inset-0 bg-primary/5 z-10 mix-blend-multiply pointer-events-none" />
                <img src="https://rolltreppenreinigung.yourbusiness.name/wp-content/uploads/2026/03/ChatGPT-Image-7.-Marz-2026-17_02_59.png" alt="ROLLTREPPENREINIGUNG – SERVICE TEAM WEINGARTEN logo" className="w-full h-full object-cover object-center scale-110" style={{
                transform: `scale(1.1) translateY(${-offsetY * 0.1}px)`
              }} />
                
                {}
                <div className="absolute bottom-8 left-8 right-8 bg-white/90 backdrop-blur-md p-6 rounded-xl shadow-lg border border-white/20 z-20 hidden md:block max-w-xs">
                  <p className="text-primary font-bold text-lg">ROLLTREPPENREINIGUNG - SERVICE TEAM WEINGARTEN</p>
                  <p className="text-sm text-muted-foreground">Ihr Partner für den perfekten ersten Eindruck.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {}
      
    </section>;
}